import type { BlueprintSortField } from '@/gql/graphql';
import { int, oneOf, text, yesNo } from '@/hooks/useUrlState';

export type BlueprintsSortColumn = 'title' | 'created' | 'updated';

/** DataGrid column `id` → GraphQL sort field for server-side sort; its keys are the values `sort` accepts. */
export const BLUEPRINT_COLUMN_SORT: Record<BlueprintsSortColumn, BlueprintSortField> = {
  title: 'TITLE',
  created: 'CREATED_AT',
  updated: 'UPDATED_AT',
};

export const BLUEPRINTS_DEFAULT_SORT: { sort: BlueprintsSortColumn; dir: 'asc' | 'desc' } = { sort: 'title', dir: 'asc' };

/** The /blueprints query string, in this order (see README "List pages, URL state"). */
export const blueprintsUrlSchema = {
  search: text(),
  ticketed: yesNo(),
  active: yesNo(),
  sort: oneOf(BLUEPRINT_COLUMN_SORT, BLUEPRINTS_DEFAULT_SORT.sort),
  dir: oneOf<'asc' | 'desc', 'asc' | 'desc'>({ asc: true, desc: true }, BLUEPRINTS_DEFAULT_SORT.dir),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};
